export const CircularTableWithChairs: React.FC<{
  tableId: number;
  tableCode:string;
  table?:any;
  status: string;
  timer?: string;
  selected?: boolean;
  onClick: () => void;
  
}> = ({ tableId, status, timer,tableCode, table, selected, onClick }) => {
  const getFillColor = () => {
    switch (status) {
      case 'available':
        return '#4CAF50'; // Green
      case 'booked':
        return '#F44336'; // Red
      case 'filled':
        return '#FFC107'; // Amber
      case 'available-soon':
        return '#FF9800'; // Orange
      default:
        return '#9E9E9E'; // Grey
    }
  };

  return (
    <svg
      onClick={onClick} // Ensures click event triggers table selection
      width="100"
      height="100"
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'pointer', margin: '10px',transform: `rotate(${(table.rotation ??0)}deg)` }}
    >
      {/* Table */}
      <circle cx="60" cy="60" r="40" fill={getFillColor()} stroke={selected ? '#0000FF' : '#FFF'} strokeWidth="4" />
      <text x="60" y="60" textAnchor="middle" dy=".3em" fontSize="12px" fill="#FFF">
        {tableCode}
      </text>
      {timer && (
        <text x="60" y="80" textAnchor="middle" fontSize="10px" fill="#FFF">
          {timer}
        </text>
      )}

      {/* Chairs */}
      <circle cx="20" cy="60" r="10" fill="#CCCCCC" />
      <circle cx="100" cy="60" r="10" fill="#CCCCCC" />
      <circle cx="60" cy="20" r="10" fill="#CCCCCC" />
      <circle cx="60" cy="100" r="10" fill="#CCCCCC" />
    </svg>
  );
};
